(function() {
  var SelectBox,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  SelectBox = App.loadClass('core::SelectBox');

  exports.Contracts_Edit_Handler = (function(superClass) {
    extend(Contracts_Edit_Handler, superClass);

    function Contracts_Edit_Handler() {
      return Contracts_Edit_Handler.__super__.constructor.apply(this, arguments);
    }

    Contracts_Edit_Handler.prototype.init = function() {
      this.layoutUrl = 'backend/portal/contracts/load-layout-edit';
      this.layoutSelector = App.sidebar.contentDiv().find('#edit');
      this.msgwriter = this.layoutSelector.find('.sidebar_message_writer');
      this.msgwriter.message_writer();
      this.msgwriter.message_writer('info', 'Loading Contracts...');
      return this.loadLayout();
    };

    Contracts_Edit_Handler.prototype.afterLoadLayout = function(selector, response) {
      var ref, ths;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      ths = this;
      this.msgwriter.message_writer('success', 'Contracts Loaded');
      this.msgwriter.message_writer('hide');
      $('#contract_edit_year').bind('change', (function(_this) {
        return function() {
          _this.parent.filterParams = {};
          return _this.filterSelects();
        };
      })(this));
      $('#contract_edit_grower').bind('change', (function(_this) {
        return function() {
          _this.parent.filterParams = {};
          $('#contract_edit_field').val('');
          return _this.filterSelects();
        };
      })(this));
      $('#contract_edit_field').bind('change', (function(_this) {
        return function() {
          _this.parent.filterParams = {};
          return _this.filterSelects();
        };
      })(this));
      $('#contract_edit_number').bind('change', function() {
        return ths.parent.loadContract($(this).val());
      });
      return this.filterSelects();
    };

    Contracts_Edit_Handler.prototype.filterSelects = function() {
      var fid, params, uid, year;
      year = $('#contract_edit_year').val();
      uid = $('#contract_edit_grower').val();
      fid = $('#contract_edit_field').val();
      if (jQuery.isEmptyObject(this.parent.filterParams)) {
        params = {};
        if (year) {
          params.year = year;
        }
        if (uid) {
          params.uid = uid;
        }
        if (fid) {
          params.fid = fid;
        }
        this.parent.filterParams = params;
      } else {
        params = this.parent.filterParams;
        params.reload = true;
      }
      return $.post('backend/portal/contracts/list-contracts', params, (function(_this) {
        return function(json) {
          json = json.data;
          if (json.growers) {
            SelectBox.render(SelectBox.prepareObject(json.growers), $('#contract_edit_grower'));
          }
          if (json.fields) {
            SelectBox.render(SelectBox.prepareObject(json.fields), $('#contract_edit_field'));
          }
          SelectBox.render(SelectBox.prepareObject(json.contracts), $('#contract_edit_number'));
          if ($('#contract_edit_number').find('option').length === 1) {
            $('#contract_edit_number').html('<option value="">No Contracts</option>');
          }
          if (!jQuery.isEmptyObject(_this.parent.filterParams)) {
            if (_this.parent.filterParams.year && $('#contract_edit_year').val() !== _this.parent.filterParams.year) {
              $('#contract_edit_year').val(_this.parent.filterParams.year);
            }
            if (_this.parent.filterParams.uid && $('#contract_edit_grower').val() !== _this.parent.filterParams.uid) {
              $('#contract_edit_grower').val(_this.parent.filterParams.uid);
            }
            if (_this.parent.filterParams.fid && $('#contract_edit_field').val() !== _this.parent.filterParams.fid) {
              return $('#contract_edit_field').val(_this.parent.filterParams.fid);
            }
          }
        };
      })(this));
    };

    Contracts_Edit_Handler.prototype.sort = function(elem) {
      var arr, oldval;
      oldval = elem.val();
      arr = elem.find('option[value!=""]').sort(this.selectSort);
      elem.empty().prepend('<option value="">Select...</option>').append(arr);
      return elem.val(oldval);
    };

    Contracts_Edit_Handler.prototype.selectSort = function(a, b) {
      if (a.text > b.text) {
        return 1;
      } else if (a.text < b.text) {
        return -1;
      }
      return 0;
    };

    return Contracts_Edit_Handler;

  })(Handler);

}).call(this);
